import { render } from "./TossPayments.vue?vue&type=template&id=f35702ec&scoped=true"
import script from "./TossPayments.vue?vue&type=script&lang=js"
export * from "./TossPayments.vue?vue&type=script&lang=js"

import "./TossPayments.vue?vue&type=style&index=0&id=f35702ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f35702ec"]])

export default __exports__